<template>
  <div>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column fixed prop="did" label="商品图片">
        <template slot-scope="scope">
          <img :src="scope.row.images" alt="" width="100px" height="100px" />
        </template>
      </el-table-column>
      <el-table-column fixed prop="did" label="订单号"> </el-table-column>
      <el-table-column prop="name" label="姓名"> </el-table-column>
      <el-table-column prop="tel" label="电话"> </el-table-column>
      <el-table-column prop="idcard" label="身份证号"> </el-table-column>
      <el-table-column prop="address" label="收货地址"> </el-table-column>
      <el-table-column prop="text" label="商品名称"> </el-table-column>
      <el-table-column prop="prick" label="金额"> </el-table-column>

      <el-table-column prop="paytime" label="下单时间"> </el-table-column>
      <el-table-column prop="way" label="取货方式"> </el-table-column>
      <el-table-column prop="sta" label="订单状态"> </el-table-column>
      <el-table-column prop="wl" label="物流单号"> </el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button
            @click="handleClick(scope.row)"
            type="text"
            size="small"
            v-if="scope.row.sta == '待发货'"
            >发货</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 发货弹窗 -->
    <div>
      <el-dialog title="发货操作" :visible.sync="dialogForm" width="30%">
        <div class="wl">
          <span> 物流单号： </span>
          <span style="width: 50%">
            <el-input v-model="trackingNumber"></el-input>
          </span>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" @click="confirm">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  name: "Orders",
  data() {
    return {
      tableData: [],
      trackingNumber: "",
      dialogForm: false,
      eid: "",
    };
  },
  methods: {
    //请求订单数据
    getOder() {
      //单次请求不超过1000条，订单数超出1000条时，需要做分页处理
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: 'db.collection("shop_dd").where({}).limit(1000).get()',
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.tableData = res.data.data;
        });
    },

    //发货
    handleClick(event) {
      this.eid = event._id;
      if (event.way == "邮寄") {
        //弹窗填写单号
        this.dialogForm = !this.dialogForm;
        // this.eid = event._id;
        // this.confirm(event._id);
        this.confirm();
        return;
      }
      //直接发货
      this.$confirm("确定将该物品发货吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.confirm();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消发货",
          });
        });
    },

    //取消操作
    cancel() {
      this.dialogForm = false;
      this.trackingNumber = "";
      this.eid = "";
    },
    //提交
    confirm() {
      this.axios
        .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("shop_dd").doc("${this.eid}").update({data:{sta:"已发货",wl:"${this.trackingNumber}"}})`,
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.$notify({
              title: "发货成功",
              message: "该物品已成功发货",
              type: "success",
            });
            this.dialogForm = false;
            this.getOder();
          }
        });
    },
  },
  created() {
    this.getTokens();
    //获取当前登录的用户数据
    this.getUserToken();
  },
  mounted() {
    setTimeout(() => {
      this.getOder();
    }, 800);
  },
};
</script>
<style scoped>
.wl {
  display: flex;
  flex-direction: row;
}
</style>
